import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 9266 19170"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#343230}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M1971 8667h5324l1371-1372V1971L7295 599H1971L599 1971v5324l1372 1372zm5447 599H1847c-79 0-155-32-212-88L88 7631c-57-57-88-133-88-212V1847c0-79 31-155 88-211L1635 88c57-56 133-88 212-88h5571c80 0 156 32 212 89l1548 1547c57 56 88 132 88 211v5572c0 79-31 155-88 212L7631 9178c-57 56-133 88-213 88z"
        className="fil0"
      />
      <path
        d="M4004 4643h1298c660 0 1198-537 1198-1198v-100c0-660-538-1198-1198-1198H4004v2496zm1298 600H3704c-165 0-299-135-299-300V1847c0-165 134-299 299-299h1598c990 0 1797 806 1797 1797v100c0 991-807 1798-1797 1798z"
        className="fil0"
      />
      <path
        d="M3704 7719c-165 0-299-135-299-300V4943c0-166 134-300 299-300s300 134 300 300v2476c0 165-135 300-300 300zM3385 9905h2496v-639H3385v639zm2796 599H3085c-165 0-299-134-299-299V8967c0-166 134-300 299-300h3096c164 0 299 134 299 300v1237c0 166-135 300-299 300z"
        className="fil0"
      />
      <path
        d="M4314 17333h638v-6829h-638v6829zm938 600H4014c-166 0-300-134-300-300v-7429c0-165 134-299 300-299h1238c165 0 299 134 299 300v7428c0 166-134 300-299 300z"
        className="fil0"
      />
      <path
        d="M909 18572h7448v-639H909v639zm7748 598H609c-166 0-300-133-300-299l1-1238c0-166 133-300 299-300h8048c165 0 299 134 299 300v1238c0 166-134 299-299 299z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
